import { DatePipe, DOCUMENT } from '@angular/common'
import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core'
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { CommonService, formatDateWith3Params } from 'src/app/services/common/common.service'
import { catchError, map, Observable, of, Subscription } from 'rxjs'
import {
  pfNumberAsyncValidator,
  uanNumberAsyncValidator,
  passportAsyncValidator,
  ppoNumberAsyncValidator,
  pastDateAsyncValidator,
  futureDateAsyncValidator,
  VALIDATORS,
  schemeCertificateNumberAsyncValidator,
  ALPHA_NUMERIC_WITHOUT_SPACES_ASYNC_VALIDATOR,
  mobileNumberAsyncValidator,
  pincodeAsyncValidator,
  emailValidator,
  bankAccountNumberAsyncValidator,
  ifscCodeAsyncValidator,
  panNumberAsyncValidator
} from 'src/app/validators/validators.validator'
import { ActivatedRoute } from '@angular/router'
import { getEmployeeFromState } from '../../store/selector/employee.selector'
import { EmployeeService } from '../../services/employee/employee.service'
import { EmployeeState } from '../../store/state/employee.state'
import { AppState } from '../../store/state/app.state'
import { Store } from '@ngrx/store'
import { Form11Service } from 'src/app/services/form11/form11.service'
import { CodeLookup, DocumentReadResponseModel, ScreenConfigValueApiModel } from 'src/app/models/api.model'
import Swal from 'sweetalert2'
import { getScreenConfigFromState } from 'src/app/store/selector/initialize.selector'
import { ConfigService } from 'src/app/services/common/config.service'
import countryCodes from '../../../assets/other/country-code.json'
import { OptionsService } from 'src/app/services/common/options.service'
import Tooltip from 'bootstrap/js/dist/tooltip'

@Component({
  selector: 'app-form11',
  templateUrl: './form11.component.html',
  styleUrls: ['./form11.component.scss']
})
export class Form11Component implements OnInit {
  @ViewChild('passbookUploadDiv') passbookUploadRef: ElementRef
  @ViewChild('pfServiceHistoryScreenshot') pfServiceHistoryScreenshotRef: ElementRef
  @ViewChild('aadharFront') aadharFrontRef: ElementRef
  @ViewChild('aadharBack') aadharBackRef: ElementRef
  @ViewChild('panCard') panCardRef: ElementRef
  @ViewChild('passport') passportRef: ElementRef

  PERSONAL_INFO_NAME = 'personalInfo'
  NAME_AS_PER_AADHAAR = 'nameAsPerAadhaar'
  DOB = 'dob'
  GENDER = 'gender'
  PAN_NUMBER = 'panNumber'
  AADHAAR_NUMBER = 'aadhaarNumber'
  FATHER_NAME = 'fatherName'
  MARITAL_STATUS = 'maritalStatus'

  CONTACT_INFO_NAME = 'contactInfo'
  MOBILE_NUMBER = 'mobileNumber'
  EMAIL_ID = 'secondaryEmailId'
  ADDRESS1 = 'address1'
  ADDRESS2 = 'address2'
  ADDRESS3 = 'address3'
  CITY = 'city'
  STATE = 'state'
  COUNTRY = 'country'
  PIN = 'pin'

  EPF_DETAILS_NAME = 'epfDetails'
  UAN_NUMBER = 'uanNumber'
  PREVIOUS_PF_ACCOUNT_NUMBER = 'previousPFAccountNumber'
  DATE_OF_EXIT_FROM_PREVIOUS_EMPLOYER = 'dateOfExitFromPreviousEmployer'
  SCHEME_CERTIFICATE_NUMBER = 'schemeCertificateNumber'
  IS_EXISTING_EPF_MEMBER = 'isExistingEPFMember'

  PASSPORT_DETAILS_NAME = 'passportDetails'
  COUNTRY_OF_ORIGIN = 'countryOfOrigin'
  PASSPORT_NUMBER = 'passportNumber'
  VALID_FROM = 'validFrom'
  VALID_TILL = 'validTill'
  IS_INTERNATIONAL_WORKER = 'isInternationalWorker'

  EPS_DETAILS_NAME = 'epsDetails'
  PENSION_PAYMENT_ORDER = 'pensionPaymentOrder'
  IS_EPS_MEMBER = 'isEPSMember'

  BANK_DETAILS_NAME = 'bankDetails'
  BANK_ACC_NUM = 'accountNumber'
  BANK_IFSC_CODE = 'ifscCode'
  acceptedFormat = `Accepted File Formats: JPEG,PNG; Max Size: 2 MB`
  passportFileAcceptedFormatMsg = `Accepted File Formats: JPEG,PNG,PDF; Max Size: 2 MB`
  passbookFileAcceptedFormatMsg = `Accepted File Formats: JPEG,PNG,PDF; Max Size: 5 MB`
  pfServiceHistoryScreenshotFileAcceptedFormatMsg = `Accepted File Formats: JPEG,PNG,PDF; Max Size: 5 MB`
  private readonly GENERATED_UAN_GROUP_NAME = 'generatedUANFormGroup'

  uploadedFiles = {
    passport: null,
    passbook: null,
    pfServiceHistoryScreenshot: null,
    aadhaarFront: null,
    aadhaarBack: null,
    pan: null
  }
  currentStep: number = 1
  stepsCovered: number[] = []
  formGroup: FormGroup
  employeeData$: Observable<EmployeeState>
  employeeDataSubscription: Subscription
  activityPageLink = `/${GlobalConstants.ROUTING.ACTIVITY}/${GlobalConstants.ROUTING.DASHBOARD}`
  dashboardPageLink = `/${GlobalConstants.ROUTING.DASHBOARD}`
  newJoineeActivityId: string
  panNumberValue: string = ''
  showModal = false

  private readonly REQUIRE_ALL_ERROR_MESSAGE = 'Please fill all the required information'
  retryCount: number = 0
  employeeId: string
  countries: { name: string }[] = countryCodes
  states: CodeLookup[]
  maritalStatuses: CodeLookup[]
  genders: CodeLookup[]
  countryCodes: { dialCode: string }[] = countryCodes

  private readonly configMap: Map<string, string> = new Map()

  readonly fieldIdToControlPathMap: { [key: string]: { path: string; isParent: boolean } } = {
    MOBILE_NUMBER: { path: `${this.CONTACT_INFO_NAME}.primaryMobileNumber`, isParent: false },
    EMAIL_ID: { path: `${this.CONTACT_INFO_NAME}.${this.EMAIL_ID}`, isParent: false },
    PERMANENT_ADDRESS: { path: `${this.CONTACT_INFO_NAME}.permanentAddress`, isParent: true },
    BANK_ACCOUNT_NUMBER: { path: `${this.BANK_DETAILS_NAME}.${this.BANK_ACC_NUM}`, isParent: false },
    BANK_IFSC: { path: `${this.BANK_DETAILS_NAME}.${this.BANK_IFSC_CODE}`, isParent: false },
    NAME_AS_IN_AADHAAR: { path: `${this.PERSONAL_INFO_NAME}.${this.NAME_AS_PER_AADHAAR}`, isParent: false },
    YOUR_DATE_OF_BIRTH: { path: `${this.PERSONAL_INFO_NAME}.${this.DOB}`, isParent: false },
    GENDER: { path: `${this.PERSONAL_INFO_NAME}.${this.GENDER}`, isParent: false },
    PAN_NUMBER: { path: `${this.PERSONAL_INFO_NAME}.${this.PAN_NUMBER}`, isParent: false },
    AADHAAR_NUMBER: { path: `${this.PERSONAL_INFO_NAME}.${this.AADHAAR_NUMBER}`, isParent: false },
    FATHER_NAME: { path: `${this.PERSONAL_INFO_NAME}.${this.FATHER_NAME}`, isParent: false },
    MARITAL_STATUS: { path: `${this.PERSONAL_INFO_NAME}.${this.MARITAL_STATUS}`, isParent: false }
  }

  hideSteps: number[] = []

  private readonly GENERATED_UAN_CONTROL_NAME = 'generatedUAN'
  isGeneratedUANRequired: boolean

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly renderer: Renderer2,
    private readonly form11Service: Form11Service,
    private readonly formBuilder: FormBuilder,
    private readonly cs: CommonService,
    private readonly route: ActivatedRoute,
    private readonly employeeService: EmployeeService,
    private readonly appState: Store<AppState>,
    private readonly datePipe: DatePipe,
    private readonly configService: ConfigService,
    private readonly optionsService: OptionsService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.newJoineeActivityId = params['id']
      this.employeeId = params['eid']
    })
    this.buildFormGroup()
    this.populateOptions()
    this.renderer.addClass(this.document.body, 'uplad-documntpg')
  }

  private buildFormGroup() {
    this.employeeService.dispatchGetEmployeeWithReferenceDetails(this.employeeId)
    this.employeeData$ = this.appState.select(getEmployeeFromState)

    this.employeeDataSubscription = this.employeeData$.subscribe(employee => {
      const referenceData = employee?.employeeComplianceReferenceDetailsOrchModel
      const bankDetails = employee?.employeeBankDetailsOrchModel
      const statutoryDetails = employee?.employeeStatutoryDetails
      const address = employee?.address
      this.panNumberValue = statutoryDetails?.pan
      this.formGroup = this.formBuilder.group({
        [this.PERSONAL_INFO_NAME]: this.formBuilder.group({
          [this.NAME_AS_PER_AADHAAR]: [
            referenceData?.nameInAadhaar || '',
            [Validators.required, VALIDATORS.ONLY_APLHABETS_WITH_SPACES, Validators.maxLength(75)]
          ],
          [this.DOB]: [
            employee?.dob
              ? this.datePipe.transform(new Date(employee.dob), 'yyyy-MM-dd', GlobalConstants.IST_OFFSET)
              : ''
          ],
          [this.GENDER]: [employee?.gender || ''],
          [this.PAN_NUMBER]: [
            statutoryDetails?.pan || '',
            { validators: [Validators.required], asyncValidators: [panNumberAsyncValidator] }
          ],
          [this.AADHAAR_NUMBER]: [statutoryDetails?.aadhaar || ''],
          [this.FATHER_NAME]: [referenceData?.fatherName || '', { validators: [Validators.maxLength(75)] }],
          [this.MARITAL_STATUS]: [employee?.maritalStatus || '']
        }),
        [this.CONTACT_INFO_NAME]: this.formBuilder.group({
          primaryMobileNumber: [
            employee?.mobileNumber?.includes('-') ? employee.mobileNumber.split('-')[1] : employee?.mobileNumber || '',
            { validators: [Validators.required], asyncValidators: [mobileNumberAsyncValidator] }
          ],
          primaryCountryCode: [employee?.mobileNumber?.includes('-') ? employee.mobileNumber.split('-')[0] : '+91'],
          [this.MOBILE_NUMBER]: [''],
          [this.EMAIL_ID]: [
            employee?.secondaryEmailId || '',
            { validators: [Validators.required, emailValidator(), Validators.maxLength(75)] }
          ],
          permanentAddress: this.formBuilder.group({
            [this.ADDRESS1]: [
              address?.address1 || '',
              [Validators.required, Validators.pattern(/^[0-9a-zA-Z#,-/\s]*$/)]
            ],
            [this.ADDRESS2]: [address?.address2 || '', [Validators.required, VALIDATORS.ALPHA_NUMERIC_WITH_SPACES]],
            [this.ADDRESS3]: [address?.address3 || '', Validators.required],
            [this.CITY]: [address?.city || '', Validators.required],
            [this.STATE]: [address?.state || '', Validators.required],
            [this.COUNTRY]: [address?.country || '', Validators.required],
            [this.PIN]: [
              address?.pin || '',
              {
                validators: [Validators.required, Validators.minLength(5), Validators.maxLength(10)],
                asyncValidators: [pincodeAsyncValidator]
              }
            ]
          })
        }),
        [this.EPF_DETAILS_NAME]: this.formBuilder.group({
          [this.UAN_NUMBER]: [
            statutoryDetails?.uanNumber || '',
            { validators: [Validators.required], asyncValidators: [uanNumberAsyncValidator] }
          ],
          [this.PREVIOUS_PF_ACCOUNT_NUMBER]: [
            statutoryDetails?.pfNumber,
            { validators: [Validators.required], asyncValidators: [pfNumberAsyncValidator] }
          ],
          [this.DATE_OF_EXIT_FROM_PREVIOUS_EMPLOYER]: [
            referenceData?.dateOfExit
              ? this.datePipe.transform(new Date(referenceData.dateOfExit), 'yyyy-MM-dd', GlobalConstants.IST_OFFSET)
              : '',
            { validators: [Validators.required], asyncValidators: [futureDateAsyncValidator] }
          ],
          [this.SCHEME_CERTIFICATE_NUMBER]: [
            referenceData?.certificateNumber || '',
            {
              validators: [],
              asyncValidators: [ALPHA_NUMERIC_WITHOUT_SPACES_ASYNC_VALIDATOR, schemeCertificateNumberAsyncValidator]
            }
          ],
          [this.IS_EXISTING_EPF_MEMBER]: [statutoryDetails?.havePfAccount === 'Yes', Validators.required]
        }),
        [this.EPS_DETAILS_NAME]: this.formBuilder.group({
          [this.PENSION_PAYMENT_ORDER]: [
            referenceData?.ppoNumber || '',
            {
              validators: [],
              asyncValidators: [ALPHA_NUMERIC_WITHOUT_SPACES_ASYNC_VALIDATOR, ppoNumberAsyncValidator]
            }
          ],
          [this.IS_EPS_MEMBER]: [(referenceData?.memberOfEmployeePensionScheme as any) === 'true']
        }),
        [this.BANK_DETAILS_NAME]: this.formBuilder.group({
          [this.BANK_ACC_NUM]: [
            bankDetails?.accountNumber || '',
            { asyncValidators: [bankAccountNumberAsyncValidator] }
          ],
          [this.BANK_IFSC_CODE]: [bankDetails?.ifscCode || '', { asyncValidators: [ifscCodeAsyncValidator] }]
        }),
        [this.PASSPORT_DETAILS_NAME]: this.formBuilder.group({
          [this.COUNTRY_OF_ORIGIN]: [referenceData?.passportCountryOfIssue || '', Validators.required],
          [this.PASSPORT_NUMBER]: [
            referenceData?.passportNumber || '',
            { validators: [Validators.required], asyncValidators: [passportAsyncValidator] }
          ],
          [this.VALID_FROM]: [
            referenceData?.passportValidFrom
              ? this.datePipe.transform(
                  new Date(referenceData.passportValidFrom),
                  'yyyy-MM-dd',
                  GlobalConstants.IST_OFFSET
                )
              : '',
            { validators: [Validators.required], asyncValidators: [futureDateAsyncValidator] }
          ],
          [this.VALID_TILL]: [
            referenceData?.passportExpiry
              ? this.datePipe.transform(
                  new Date(referenceData.passportExpiry),
                  'yyyy-MM-dd',
                  GlobalConstants.IST_OFFSET
                )
              : '',
            { validators: [Validators.required], asyncValidators: [pastDateAsyncValidator] }
          ],
          [this.IS_INTERNATIONAL_WORKER]: [(referenceData?.internationalWorker as any) === 'true', Validators.required]
        }),
        [this.GENERATED_UAN_GROUP_NAME]: this.formBuilder.group({
          [this.GENERATED_UAN_CONTROL_NAME]: ['', { validators: [], asyncValidators: [uanNumberAsyncValidator] }]
        })
      })
      this.addEPFDetailsValidation()
      this.addPassportDetailsValidation()
      this.addEPSDetailsValidation()

      this.appState.select(getScreenConfigFromState('ADMIN_NEW_JOINEE_WORKFLOW_CONFIG')).subscribe(screenConfig => {
        if (screenConfig) {
          this.applyConfig(screenConfig.values)
          this.configService.applyConfigToForm(this.formGroup, this.configMap, this.fieldIdToControlPathMap)
        }
      })
      this.updateGeneratedUANValidation()
    })
  }

  private addEPFDetailsValidation() {
    const epfDetails = this.formGroup.get(this.EPF_DETAILS_NAME) as FormGroup

    epfDetails.get(this.IS_EXISTING_EPF_MEMBER).valueChanges.subscribe(isExistingEPFMember => {
      if (isExistingEPFMember) {
        epfDetails.get(this.UAN_NUMBER)?.setValidators([Validators.required])
        epfDetails.get(this.UAN_NUMBER)?.setAsyncValidators([uanNumberAsyncValidator])

        epfDetails.get(this.PREVIOUS_PF_ACCOUNT_NUMBER)?.setValidators([Validators.required])
        epfDetails.get(this.PREVIOUS_PF_ACCOUNT_NUMBER)?.setAsyncValidators([pfNumberAsyncValidator])

        epfDetails.get(this.DATE_OF_EXIT_FROM_PREVIOUS_EMPLOYER)?.setValidators([Validators.required])
        epfDetails.get(this.DATE_OF_EXIT_FROM_PREVIOUS_EMPLOYER)?.setAsyncValidators([futureDateAsyncValidator])

        epfDetails.get(this.SCHEME_CERTIFICATE_NUMBER)?.setAsyncValidators([schemeCertificateNumberAsyncValidator])

        epfDetails.get(this.UAN_NUMBER)?.enable()
        epfDetails.get(this.PREVIOUS_PF_ACCOUNT_NUMBER)?.enable()
        epfDetails.get(this.DATE_OF_EXIT_FROM_PREVIOUS_EMPLOYER)?.enable()
        epfDetails.get(this.SCHEME_CERTIFICATE_NUMBER)?.enable()
      } else {
        epfDetails.get(this.UAN_NUMBER)?.clearValidators()
        epfDetails.get(this.UAN_NUMBER)?.clearAsyncValidators()
        epfDetails.get(this.UAN_NUMBER)?.setValue('')

        epfDetails.get(this.PREVIOUS_PF_ACCOUNT_NUMBER)?.clearValidators()
        epfDetails.get(this.PREVIOUS_PF_ACCOUNT_NUMBER)?.clearAsyncValidators()
        epfDetails.get(this.PREVIOUS_PF_ACCOUNT_NUMBER)?.setValue('')

        epfDetails.get(this.DATE_OF_EXIT_FROM_PREVIOUS_EMPLOYER)?.clearValidators()
        epfDetails.get(this.DATE_OF_EXIT_FROM_PREVIOUS_EMPLOYER)?.clearAsyncValidators()
        epfDetails.get(this.DATE_OF_EXIT_FROM_PREVIOUS_EMPLOYER)?.setValue('')

        epfDetails.get(this.SCHEME_CERTIFICATE_NUMBER)?.clearValidators()
        epfDetails.get(this.SCHEME_CERTIFICATE_NUMBER)?.clearAsyncValidators()
        epfDetails.get(this.SCHEME_CERTIFICATE_NUMBER)?.setValue('')

        epfDetails.get(this.UAN_NUMBER)?.disable()
        epfDetails.get(this.PREVIOUS_PF_ACCOUNT_NUMBER)?.disable()
        epfDetails.get(this.DATE_OF_EXIT_FROM_PREVIOUS_EMPLOYER)?.disable()
        epfDetails.get(this.SCHEME_CERTIFICATE_NUMBER)?.disable()
      }

      epfDetails.get(this.UAN_NUMBER).updateValueAndValidity()
      epfDetails.get(this.PREVIOUS_PF_ACCOUNT_NUMBER).updateValueAndValidity()
      epfDetails.get(this.DATE_OF_EXIT_FROM_PREVIOUS_EMPLOYER).updateValueAndValidity()
      epfDetails.get(this.SCHEME_CERTIFICATE_NUMBER).updateValueAndValidity()
      this.updateGeneratedUANValidation()
    })
  }

  private addEPSDetailsValidation() {
    const epsDetails = this.formGroup.get(this.EPS_DETAILS_NAME) as FormGroup

    epsDetails.get(this.IS_EPS_MEMBER).valueChanges.subscribe(isExistingEPSMember => {
      if (isExistingEPSMember) {
        epsDetails.get(this.PENSION_PAYMENT_ORDER)?.setAsyncValidators([ppoNumberAsyncValidator])
        epsDetails.get(this.PENSION_PAYMENT_ORDER)?.enable()
      } else {
        epsDetails.get(this.PENSION_PAYMENT_ORDER)?.clearValidators()
        epsDetails.get(this.PENSION_PAYMENT_ORDER)?.clearAsyncValidators()
        epsDetails.get(this.PENSION_PAYMENT_ORDER)?.setValue('')
        epsDetails.get(this.PENSION_PAYMENT_ORDER)?.disable()
      }

      epsDetails.get(this.PENSION_PAYMENT_ORDER).updateValueAndValidity()
    })
  }

  private addPassportDetailsValidation() {
    const passportDetails = this.formGroup.controls[this.PASSPORT_DETAILS_NAME]

    passportDetails.get(this.IS_INTERNATIONAL_WORKER)?.valueChanges.subscribe(value => {
      if (value) {
        passportDetails.get(this.PASSPORT_NUMBER)?.setValidators([Validators.required])
        passportDetails.get(this.PASSPORT_NUMBER)?.setAsyncValidators([passportAsyncValidator])
        passportDetails.get(this.VALID_FROM)?.setValidators([Validators.required])
        passportDetails.get(this.VALID_FROM)?.setAsyncValidators([futureDateAsyncValidator])

        passportDetails.get(this.VALID_TILL)?.setValidators([Validators.required])
        passportDetails.get(this.VALID_TILL)?.setAsyncValidators([pastDateAsyncValidator])

        passportDetails.get(this.COUNTRY_OF_ORIGIN)?.setValidators([Validators.required])

        passportDetails.get(this.PASSPORT_NUMBER)?.enable()
        passportDetails.get(this.VALID_FROM)?.enable()
        passportDetails.get(this.VALID_TILL)?.enable()
        passportDetails.get(this.COUNTRY_OF_ORIGIN)?.enable()
      } else {
        passportDetails.get(this.PASSPORT_NUMBER)?.clearValidators()
        passportDetails.get(this.PASSPORT_NUMBER)?.clearAsyncValidators()
        passportDetails.get(this.VALID_FROM)?.clearValidators()
        passportDetails.get(this.VALID_TILL)?.clearValidators()
        passportDetails.get(this.VALID_FROM)?.clearAsyncValidators()
        passportDetails.get(this.VALID_TILL)?.clearAsyncValidators()
        passportDetails.get(this.COUNTRY_OF_ORIGIN)?.clearValidators()

        passportDetails.get(this.PASSPORT_NUMBER)?.setValue('')
        passportDetails.get(this.VALID_FROM)?.setValue('')
        passportDetails.get(this.VALID_TILL)?.setValue('')
        passportDetails.get(this.COUNTRY_OF_ORIGIN)?.setValue('')

        passportDetails.get(this.PASSPORT_NUMBER)?.disable()
        passportDetails.get(this.VALID_FROM)?.disable()
        passportDetails.get(this.VALID_TILL)?.disable()
        passportDetails.get(this.COUNTRY_OF_ORIGIN)?.disable()
      }

      passportDetails.get(this.PASSPORT_NUMBER).updateValueAndValidity()
      passportDetails.get(this.VALID_FROM).updateValueAndValidity()
      passportDetails.get(this.VALID_TILL).updateValueAndValidity()
      passportDetails.get(this.COUNTRY_OF_ORIGIN)?.updateValueAndValidity()
      this.updateGeneratedUANValidation()
    })
  }

  get f() {
    return this.formGroup.controls
  }

  getControl(controlPath: string): AbstractControl | null {
    const control = this.formGroup.get(controlPath)
    return control || null
  }

  onInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement
    const newValue = inputElement.value.toUpperCase()
    inputElement.value = newValue
    this.panNumberValue = newValue
  }

  onChooseFile(files: File[], imageShowElementRef: ElementRef) {
    if (files && files[0]) {
      const reader = new FileReader()
      reader.onload = e => {
        imageShowElementRef.nativeElement.innerHTML = '<img src="' + e.target.result + '" class="img-fluid" />'
      }
      reader.readAsDataURL(files[0])
    }
  }

  get isAadhaarAndPanUploaded() {
    if (this.isFieldHidden('UPLOAD_DOCUMENTS_PAGE')) {
      return true
    }
    const { aadhaarFront, aadhaarBack, pan } = this.uploadedFiles

    const isPanRequired = this.isFieldMandatory('UPLOAD_PAN')
    const isAadhaarFrontRequired = this.isFieldMandatory('UPLOAD_AADHAAR_FRONT')
    const isAadhaarBackRequired = this.isFieldMandatory('UPLOAD_AADHAAR_BACK')

    if (isAadhaarFrontRequired && !aadhaarFront) return false
    if (isAadhaarBackRequired && !aadhaarBack) return false
    if (isPanRequired && !pan) return false

    return true
  }

  private invokeForm11UploadAndReadAPI(moveToStep: number): void {
    this.form11Service
      .invokeForm11UploadAndReadAPI(
        this.uploadedFiles.aadhaarFront,
        this.uploadedFiles.aadhaarBack,
        this.uploadedFiles.pan,
        this.newJoineeActivityId
      )
      .pipe(
        map((response: DocumentReadResponseModel[]) => {
          let pan: string
          let aadhaarDetails: any
          let name: string
          let dob: string
          let gender: string
          let address: string
          let aadhaar: string

          for (const documentResponse of response) {
            if (documentResponse.document === GlobalConstants.DocType.PAN && documentResponse.readSuccess) {
              pan = documentResponse.data['pan']?.value
            } else if (documentResponse.document === GlobalConstants.DocType.AADHAAR && documentResponse.readSuccess) {
              aadhaarDetails = documentResponse.data
              if (aadhaarDetails) {
                name = aadhaarDetails?.name?.value
                dob = aadhaarDetails?.dob?.value
                gender = aadhaarDetails?.gender?.value
                address = aadhaarDetails?.address?.value
                aadhaar = aadhaarDetails?.aadhaar?.value
              }
            }
          }

          this.formGroup.patchValue({
            personalInfo: {
              nameAsPerAadhaar: name || '',
              gender: gender?.toUpperCase() || '',
              aadhaarNumber: aadhaar || '',
              panNumber: pan || '',
              dob: dob?.includes('/') ? formatDateWith3Params(dob, 'dd/MM/yyyy', 'yyyy-MM-dd') : ''
            },
            contactInfo: { permanentAddress: { address1: address || '' } }
          })
          this.currentStep = moveToStep
          this.stepsCovered.push(moveToStep - 1)
        }),
        catchError((error: any) => {
          this.handleDocFailedCase(moveToStep)
          return of(null)
        })
      )
      .subscribe()
  }

  private moveAndResetRetryCount() {
    this.currentStep = 2
    this.retryCount = 0
    this.uploadedFiles = { ...this.uploadedFiles, aadhaarFront: null, aadhaarBack: null, pan: null }
  }

  private handleDocFailedCase(moveToStep: number) {
    if (this.retryCount === 0) {
      Swal.fire({
        title: `We are unable to read the data from docs?`,
        icon: 'warning',
        showDenyButton: true,
        confirmButtonText: 'I want to retry',
        denyButtonText: 'No, I want to fill manually',
        color: '#000',
        confirmButtonColor: '#0452d7',
        denyButtonColor: '#444C66'
      }).then(result => {
        if (result.isConfirmed) {
          this.retryCount++
          this.invokeForm11UploadAndReadAPI(moveToStep)
        } else {
          this.moveAndResetRetryCount()
        }
      })
    } else {
      this.cs.showInfo('Unable to read data from docs, Moving to next step where you can fill data manually')
      this.moveAndResetRetryCount()
    }
  }

  moveTo(step: number) {
    if (step > this.currentStep) {
      switch (step) {
        case 2:
          if (!this.isAadhaarAndPanUploaded) {
            return this.cs.showError('Upload all files')
          }
          if (
            this.uploadedFiles.aadhaarFront !== null ||
            this.uploadedFiles.aadhaarBack !== null ||
            this.uploadedFiles.pan !== null
          ) {
            this.invokeForm11UploadAndReadAPI(step)
          } else {
            this.currentStep += 1
            this.stepsCovered.push(step - 1)
          }
          break
        case 3:
          if (this.isContactInfoPageHidden()) {
            this.currentStep = step + 1
            this.stepsCovered.push(step)
            break
          }
          this.getControl(this.PERSONAL_INFO_NAME).markAllAsTouched()
          if (this.getControl(this.PERSONAL_INFO_NAME).invalid) {
            return this.cs.showError(this.REQUIRE_ALL_ERROR_MESSAGE)
          }
          this.currentStep = step
          this.stepsCovered.push(step - 1)
          break
        case 4:
          this.getControl(this.CONTACT_INFO_NAME).markAllAsTouched()
          if (!this.isFieldHidden('PERMANENT_ADDRESS')) {
            this.getControl('contactInfo.permanentAddress').markAllAsTouched()
          }
          if (
            this.getControl(this.CONTACT_INFO_NAME).invalid ||
            this.getControl('contactInfo.permanentAddress')?.invalid
          ) {
            return this.cs.showError(this.REQUIRE_ALL_ERROR_MESSAGE)
          }
          this.currentStep = step
          this.stepsCovered.push(step - 1)
          break
        case 5: {
          this.getControl(this.EPF_DETAILS_NAME)?.markAllAsTouched()
          this.getControl(this.PASSPORT_DETAILS_NAME)?.markAllAsTouched()
          this.getControl(this.EPS_DETAILS_NAME)?.markAllAsTouched()

          const isExistingEpfMember = this.formGroup.get(this.EPF_DETAILS_NAME)?.get(this.IS_EXISTING_EPF_MEMBER)?.value
          const isInternationalWorker = this.formGroup.controls[this.PASSPORT_DETAILS_NAME]?.get(
            this.IS_INTERNATIONAL_WORKER
          )?.value
          const isEPSMember = this.formGroup.get(this.EPS_DETAILS_NAME)?.get(this.IS_EPS_MEMBER)?.value
          if (!isExistingEpfMember) {
            this.clearValidatorsForGroup(this.EPF_DETAILS_NAME)
          }
          if (!isInternationalWorker) {
            this.clearValidatorsForGroup(this.PASSPORT_DETAILS_NAME)
          }
          if (!isEPSMember) {
            this.clearValidatorsForGroup(this.EPS_DETAILS_NAME)
          }
          if (
            (isExistingEpfMember && this.getControl(this.EPF_DETAILS_NAME).invalid) ||
            (isInternationalWorker && this.getControl(this.PASSPORT_DETAILS_NAME).invalid) ||
            (isEPSMember && this.getControl(this.EPS_DETAILS_NAME).invalid)
          ) {
            return this.cs.showError(this.REQUIRE_ALL_ERROR_MESSAGE)
          } else if (this.isPassbookUploadMandatory) {
            this.passbookUploadRef.nativeElement.focus()
            return this.cs.showError(this.REQUIRE_ALL_ERROR_MESSAGE)
          } else if (this.isPFServiceHistoryUploadMandatory) {
            this.pfServiceHistoryScreenshotRef.nativeElement.focus()
            return this.cs.showError(this.REQUIRE_ALL_ERROR_MESSAGE)
          } else if (this.isPassportUploadMandatory) {
            this.passportRef.nativeElement.focus()
            return this.cs.showError(this.REQUIRE_ALL_ERROR_MESSAGE)
          }
          this.invokeUpdateReferenceDetailsAPI(step)
          break
        }
        default:
          break
      }
    } else if (step == 3 && this.isContactInfoPageHidden()) {
      this.currentStep = step - 1
    } else {
      this.currentStep = step
    }
  }

  private invokeUpdateReferenceDetailsAPI(moveTo: number) {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched()
      return this.cs.showError(this.REQUIRE_ALL_ERROR_MESSAGE)
    }

    let formattedPrimaryMobileNo = ''
    const mobileNo = this.getControl('contactInfo.primaryMobileNumber')?.value
    const code = this.formGroup.get('contactInfo.primaryCountryCode')?.value
    if (mobileNo && code) {
      formattedPrimaryMobileNo = `${code}-${mobileNo}`
    }
    this.formGroup.get('contactInfo.mobileNumber').setValue(formattedPrimaryMobileNo)

    const generatedUAN = this.getControl('generatedUANFormGroup.generatedUAN')?.value

    this.form11Service
      .invokeUpdateReferenceDetailsAPI(
        { ...this.formGroup.value, generatedUAN },
        this.uploadedFiles.passport,
        this.uploadedFiles.passbook,
        this.uploadedFiles.pfServiceHistoryScreenshot,
        this.newJoineeActivityId,
        this.employeeId
      )
      .pipe(
        map(() => {
          this.currentStep = moveTo
          this.stepsCovered.push(moveTo - 1)
        }),
        catchError(() => {
          this.cs.showError('Unable to save')
          return of(null)
        })
      )
      .subscribe()
  }

  downloadForm11() {
    this.form11Service.invokeDownloadForm11API(this.employeeId)
  }

  handleCurrentStepEvent(step: number) {
    if (this.stepsCovered.includes(step)) {
      this.currentStep = step
    }
  }

  goToDashboard() {
    this.renderer.removeClass(this.document.body, 'uplad-documntpg')
  }

  ngOnDestroy() {
    this.employeeDataSubscription?.unsubscribe()
  }

  onInput(event: any) {
    const inputElement = event.target as HTMLInputElement
    const inputValue = inputElement.value
    const sanitizedValue = inputValue.replace(/[^0-9]/g, '')
    inputElement.value = sanitizedValue
  }

  validateUAN(event: any) {
    const inputElement = event.target as HTMLInputElement
    const inputValue = inputElement.value
    const sanitizedValue = inputValue.replace(/[^0-9]/g, '')
    inputElement.value = sanitizedValue
  }

  validatePFNumber(event: any) {
    const inputElement = event.target as HTMLInputElement
    inputElement.value = inputElement.value.toUpperCase()
  }

  goToNewJoineeActivity() {
    const url = `/${GlobalConstants.ROUTING.ACTIVITY}/${this.newJoineeActivityId}/${GlobalConstants.ROUTING.DETAILS}`
    this.cs.routeTo(url)
    this.renderer.removeClass(this.document.body, 'uplad-documntpg')
  }

  private clearValidatorsForGroup(groupName: string) {
    const group = this.formGroup.get(groupName) as FormGroup
    if (group) {
      Object.keys(group.controls).forEach(key => {
        const control = group.get(key)
        if (control) {
          control.clearValidators()
          control.clearAsyncValidators()
          control.updateValueAndValidity()
        }
      })
    }
  }

  private populateOptions() {
    const lookupValues: string[] = [
      GlobalConstants.OPTION_TYPE.STATE,
      GlobalConstants.OPTION_TYPE.MARITAL_TYPE,
      GlobalConstants.OPTION_TYPE.GENDER
    ]
    this.optionsService.getOptionsForType(lookupValues).subscribe({
      next: responses => {
        if (responses) {
          this.maritalStatuses = responses?.[GlobalConstants.OPTION_TYPE.MARITAL_TYPE]
          this.genders = responses?.[GlobalConstants.OPTION_TYPE.GENDER]
          this.states = responses?.[GlobalConstants.OPTION_TYPE.STATE]
        }
      }
    })
  }

  get isPassbookUploadMandatory() {
    const epfDetails = this.formGroup.get(this.EPF_DETAILS_NAME) as FormGroup
    const isExistingEPFMember = epfDetails?.get(this.IS_EXISTING_EPF_MEMBER)?.value
    const { passbook } = this.uploadedFiles
    const passbookUploadMandatory = this.isFieldMandatory('UPLOAD_PASSBOOK')

    return isExistingEPFMember && passbookUploadMandatory && !passbook
  }

  get isPFServiceHistoryUploadMandatory() {
    const epfDetails = this.formGroup.get(this.EPF_DETAILS_NAME) as FormGroup
    const isExistingEPFMember = epfDetails?.get(this.IS_EXISTING_EPF_MEMBER)?.value
    const { pfServiceHistoryScreenshot } = this.uploadedFiles
    const pfServiceHistoryUploadMandatory = this.isFieldMandatory('UPLOAD_SERVICE_HISTORY_SS')
    return isExistingEPFMember && pfServiceHistoryUploadMandatory && !pfServiceHistoryScreenshot
  }

  get isPassportUploadMandatory() {
    const passportDetails = this.formGroup.get(this.PASSPORT_DETAILS_NAME) as FormGroup
    const isInternationalWorker = passportDetails?.get(this.IS_INTERNATIONAL_WORKER)?.value
    const { passport } = this.uploadedFiles
    const isPassportMandatory = this.isFieldMandatory('UPLOAD_PASSPORT')
    return isInternationalWorker && isPassportMandatory && !passport
  }

  private applyConfig(values: ScreenConfigValueApiModel[]) {
    values.forEach(item => {
      this.configMap.set(item.fieldId, item.fieldValue)
    })

    if (this.isUploadDocumentsPageHidden()) {
      if (this.currentStep === 1) {
        this.currentStep = 2
        this.stepsCovered.push(this.currentStep - 1)
      }
      this.hideSteps.push(1)
    }

    if (this.isPersonalDetailsPageHidden()) {
      if (this.currentStep === 2) {
        this.currentStep = 3
        this.stepsCovered.push(this.currentStep - 1)
      }
      this.hideSteps.push(2)
    }

    if (this.isContactInfoPageHidden()) {
      if (this.currentStep === 3) {
        this.currentStep = 4
        this.stepsCovered.push(this.currentStep - 1)
      }
      this.hideSteps.push(3)
    }
  }

  isFieldHidden(fieldId: string): boolean {
    return this.configService.isFieldHidden(this.configMap, fieldId)
  }

  isFieldMandatory(fieldId: string): boolean {
    return this.configService.isFieldMandatory(this.configMap, fieldId)
  }

  isFieldOptional(fieldId: string): boolean {
    return this.configService.isFieldOptional(this.configMap, fieldId)
  }

  isFieldHiddenOrOptional(fieldId: string): boolean {
    return this.isFieldHidden(fieldId) || this.isFieldOptional(fieldId)
  }

  isContactInfoPageHidden(): boolean {
    return (
      this.isFieldHidden('MOBILE_NUMBER') && this.isFieldHidden('EMAIL_ID') && this.isFieldHidden('PERMANENT_ADDRESS')
    )
  }

  isUploadDocumentsPageHidden(): boolean {
    return (
      this.isFieldHidden('UPLOAD_DOCUMENTS_PAGE') ||
      (this.isFieldHidden('UPLOAD_PAN') &&
        this.isFieldHidden('UPLOAD_AADHAAR_FRONT') &&
        this.isFieldHidden('UPLOAD_AADHAAR_BACK'))
    )
  }

  isPersonalDetailsPageHidden(): boolean {
    return (
      this.isFieldHidden('NAME_AS_IN_AADHAAR') &&
      this.isFieldHidden('YOUR_DATE_OF_BIRTH') &&
      this.isFieldHidden('GENDER') &&
      this.isFieldHidden('PAN_NUMBER') &&
      this.isFieldHidden('AADHAAR_NUMBER') &&
      this.isFieldHidden('FATHER_NAME') &&
      this.isFieldHidden('MARITAL_STATUS')
    )
  }

  openModal() {
    this.showModal = true
  }

  closeModal() {
    this.showModal = false
  }

  updateGeneratedUANValidation(): void {
    this.isGeneratedUANRequired =
      !this.getControl(`${this.PASSPORT_DETAILS_NAME}.${this.IS_INTERNATIONAL_WORKER}`)?.value &&
      !this.getControl(`${this.EPF_DETAILS_NAME}.${this.IS_EXISTING_EPF_MEMBER}`)?.value

    const generatedUANFormControl = this.formGroup.controls[this.GENERATED_UAN_GROUP_NAME].get(
      this.GENERATED_UAN_CONTROL_NAME
    )

    if (this.isGeneratedUANRequired) {
      generatedUANFormControl?.setValidators([Validators.required])
    } else {
      generatedUANFormControl?.clearValidators()
    }
    generatedUANFormControl?.updateValueAndValidity()
  }

  ngAfterViewInit() {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map((el: any) => new Tooltip(el))
  }

  get isExistingEpfMember(): boolean {
    return this.formGroup.get(this.EPF_DETAILS_NAME)?.get(this.IS_EXISTING_EPF_MEMBER)?.value
  }
}
